export enum RouteType {
  Carrier = 1,
  Shipper = 2,
  Admin = 3,
}
